<template>
  <div class="custom_vcalendar custom_vcalendar_rounded">
    <div class="custom_vcalendar_title">
      <label class="custom_vcalendar_display_title">{{ title }}</label>
      <div class="custom_vcalendar_selects">
        <select class="custom_vcalendar_selectbox" v-model="currentDate.year" @change="yearSelected">
          <option v-for="year in optionYears" :key="year" :value="year">{{ year }}년</option>
        </select>
        <select class="custom_vcalendar_selectbox" v-model="currentDate.month" @change="monthSelected">
          <option v-for="month in optionMonth" :key="month" :value="month">{{ month+1 }}월</option>
        </select>
      </div>
    </div>
    <table class="custom_vcalendar_body">
      <thead class="custom_vcalendar_title">
      <tr>
        <td v-for="(weekName, index) in weekNames" :key="index" :class="colorStyle(index)">
          {{ weekName }}
        </td>
      </tr>
      </thead>
      <tbody class="custom_vcalendar_weeks">
      <tr v-for="(week, index) in calendarDays" :key="index">
        <td v-for="(day, index) in week" :key="index"
            :class="colorStyle(day.date.getDay())"
            @click="selectedDay(day.date)">
          <span class="daySpan" :class="daysStyle(day.date, day.class)">{{ day.date.getDate() }}</span>
          <div class="dot" v-show="dotDisplay(day.date)">
            <div class="dot_count">{{ dotDisplay(day.date) }}회</div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'Calendar',
  props: {
    dates: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      weekNames: ['일', '월', '화', '수', '목', '금', '토'],
      toDay: new Date(),
      currentDate: {
        date: 0,
        month: 0,
        year: 0
      },
      calendarDays: []
    }
  },
  created () {
    this.getCurrentDate()
  },
  mounted () {
    this.initCalendarDays()
  },
  computed: {
    title () {
      return `${this.zeroFill(this.currentDate.year)}.${this.zeroFill(this.currentDate.month + 1)}`
    },
    optionYears () {
      const year = new Date().getFullYear()
      return Array.from({ length: 6 }, (value, index) => (year - 3) + index)
    },
    optionMonth () {
      return Array.from({ length: 12 }, (value, index) => index)
    }
  },
  methods: {
    initCalendarDays: function () {
      this.calendarDays = []
      let startDay = new Date(this.currentDate.year, this.currentDate.month, 1) // 01.03.2020 - Sunday
      let firstDay = new Date(startDay)
      let inDay
      let lastDay = new Date(this.currentDate.year, this.currentDate.month + 1, 0) // 31.03.2020 - Tuesday
      let startFrom = ((startDay.getDay() + 6) % 7) + 1 // 0 - Monday == 0 + 1 == Sunday
      let endFrom = ((lastDay.getDay() + 6) % 7) + 1 // 6 - Sunday == 6 + 1 == saturday

      // Last Sunday of previous month
      startDay.setDate(startDay.getDate() - startFrom) // 24
      inDay = new Date(startDay)

      // First saturday in the next month
      lastDay.setDate(lastDay.getDate() + (7 - endFrom)) // 5

      let week = []
      while (startDay <= lastDay) {
        let style = ''
        if (startDay.getMonth() !== firstDay.getMonth()) {
          style = 'gray'
        } else {
          style = ''
        }
        week.push({ date: new Date(startDay), class: style })
        if (week.length === 7) {
          this.calendarDays.push(week)
          // 초기화
          week = []
        }
        startDay.setDate(startDay.getDate() + 1)
        // 6줄 채우기 위해
        if ((startDay > lastDay) && this.calendarDays.length < 6) {
          lastDay.setDate(lastDay.getDate() + 7) // 5
        }
      }

      this.$emit('changeCalendar', inDay, lastDay)
    },
    selectedDay (date) {
      let targetDay = new Date(date)
      this.currentDate.date = targetDay.getDate()
      this.$emit('selectedDay', date)
    },
    yearSelected (v) {
      // console.log('yearSelected', v.target.value)
      this.currentDate.year = parseInt(v.target.value)
      this.initCalendarDays()
    },
    monthSelected (v) {
      // console.log('monthSelected', v.target.value)
      this.currentDate.month = parseInt(v.target.value)
      this.initCalendarDays()
    },
    getCurrentDate: function () {
      let today = new Date()
      this.currentDate.date = today.getDate()
      this.currentDate.month = today.getMonth()
      this.currentDate.year = today.getFullYear()
    },
    zeroFill: (v) => {
      return v < 10 ? '0' + v : (v + '')
    },
    colorStyle: (i) => {
      if (i === 0) return 'sun'
      if (i === 6) return 'sat'
      return ''
    },
    daysStyle (date, oldClass) {
      let addClass = ''
      let today = new Date(this.toDay.getFullYear(), this.toDay.getMonth(), this.toDay.getDate())
      let targetDay = new Date(date)
      let selectedDay = new Date(this.currentDate.year, this.currentDate.month, this.currentDate.date)
      if (today.getTime() === targetDay.getTime()) {
        addClass = addClass + ' today '
      }
      if (selectedDay.getTime() === targetDay.getTime()) {
        addClass = addClass + ' active '
      }

      return oldClass + addClass
    },
    dotDisplay (date) {
      let y = date.getFullYear() + ''
      let m = this.zeroFill(date.getMonth() + 1)
      let d = this.zeroFill(date.getDate())
      let target = _.find(this.dates, { 'indate': `${y}-${m}-${d}` })

      return (target) ? target.cnt : 0
    }
  }
}
</script>

<style lang="scss" scoped>
.custom_vcalendar {
  color: #333;
  &.custom_vcalendar_rounded {
    -moz-border-radius: .25rem;
    border-radius: .25rem;
    border: solid 1px #ffffff;
    background-color: #fff;
    padding: 10px;

    min-width: 285px;
    max-width: 300px;
  }

  .custom_vcalendar_title {
    height: 35px;
    position: relative;

    .custom_vcalendar_display_title {
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 35px;
      position: absolute;
      left: 10px;
      top: 0px;
      margin: 0px;
    }

    .custom_vcalendar_selects {
      position: absolute;
      right: 10px;
      top: 0px;

      .custom_vcalendar_selectbox {
        display: inline-block;
        padding: .275rem .45rem;
        font-size: .9rem;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
      }

      .custom_vcalendar_selectbox:first-child {
        width: 90px;
      }

      .custom_vcalendar_selectbox:last-child {
        margin-left: 5px;
        width: 70px;
      }
    }
  }

  .custom_vcalendar_body {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    table-layout: fixed;

    .sun {
      color: #F9385F;
    }

    .sat {
      color: #3f7aff;
    }

    .gray {
      color: #b6b6b6 !important;
    }

    .today {
      display: block;
      border-radius: 50%;
      border: solid 1px #ffffff;
      background-color: #cbcaca;
      padding: 10px;
      color: #ffffff;
      cursor: pointer;
    }

    .custom_vcalendar_title {
      border-bottom: 1px solid #F0F0F0;

      td {
        font-style: normal;
        font-weight: bold;
        font-size: .9rem;
        line-height: 17px;
        text-align: center;
        padding: 5px 0px 15px;
      }
    }

    .custom_vcalendar_weeks {
      td {
        position: relative;
        font-style: normal;
        font-weight: normal;
        font-size: .9rem;
        line-height: 17px;
        text-align: center;
        height: 40px;


        .dot {
          position: absolute;
          left: 50%;
          bottom: 2px;
          margin-left: -4px;
          width: 6px;
          height: 6px;
          border: 0px solid #000;
          border-radius: 50%;
          background-color: #007DEF;

          .dot_count {
            display: none;
          }
        }
        .daySpan.active {
          display: block;
          border-radius: 50%;
          border: solid 1px #ffffff;
          background-color: #2b6bd1;
          padding: 10px;
          color: #ffffff;
          cursor: pointer;
        }
      }

      td:hover {
        .daySpan {
          display: block;
          border-radius: 50%;
          border: solid 1px #ffffff;
          background-color: #2b6bd1;
          padding: 10px;
          color: #ffffff;
          cursor: pointer;
        }

        .dot .dot_count {
          display: block;
          text-align: center;
          width: 30px;
          position: absolute;
          bottom: -15px;
          left: -13px;
          font-size: 70%;
          word-break: break-all;
          word-wrap: break-word;
          z-index: 10;
          background-color: #007DEF;
          color: #fff;
        }
      }

    }
  }


}
</style>
